import React from 'react';
import { useAutoRollCountdown } from '@root/hooks';
import { roundSelector } from '@root/store/slices/roundSlice';
import { useTypedSelector } from '@root/store/store';
import { useTranslation } from 'react-i18next';
import styles from './RunList.module.scss';

// Ticks 4x a second, so keep it here and not in the whole list.
const ActiveRoundNote: React.FC = () => {
  const { t } = useTranslation();
  const { round } = useTypedSelector(roundSelector);
  const seconds = useAutoRollCountdown(round?.state?.rollDeadline, true);

  if (seconds <= 0) return null;

  return (
    <p className={styles.active}>
      {t('Active round · auto-roll in {{seconds}}s', { seconds })}
    </p>
  );
};

export default ActiveRoundNote;
